export enum ActionTypes {
  LOAD_ALERTS_REQUEST = 'LOAD_ALERTS_REQUEST',
  LOAD_ALERTS_SUCCEEDED = 'LOAD_ALERTS_SUCCEEDED',
  LOAD_ALERTS_FAILED = 'LOAD_ALERTS_FAILED',
}
